/**
 * @author Omar Sánchez Martínez
 * @since 13/03/2026
 * @description Service for invoice cancellation and polling
 */
import { apiMunzen } from '@/app/api/apiMunzen/index';
import type { ApiResponse } from '@/common/types';
import type { CancellationResponse, CancellationStatusResponse } from '../types/cancellation.types';
import type { CancelarComprobanteForm } from '../types/comprobanteActions.interface';

const COMPROBANTES_BASE_URL = 'comprobantes/v40';

/**
 * Cancel an invoice (handles immediate and async/pending responses)
 * @param cancelacionData - Cancellation form data
 * @returns Promise with invoice data or pending response
 */
export const cancelarComprobanteService = async (
  cancelacionData: CancelarComprobanteForm,
): Promise<CancellationResponse> => {
  const response = await apiMunzen.post<CancellationResponse>(
    `${COMPROBANTES_BASE_URL}/cancelar-factura`,
    cancelacionData,
  );
  return response.data;
};

/**
 * Get cancellation status for a pending invoice
 * @param comprobanteId - Invoice ID
 * @returns Promise with cancellation status details
 */
export const getCancellationStatusService = async (
  comprobanteId: number,
): Promise<CancellationStatusResponse> => {
  const response = await apiMunzen.get<ApiResponse<CancellationStatusResponse>>(
    `${COMPROBANTES_BASE_URL}/${comprobanteId}/cancellation-status`,
  );

  return response.data.data;
};
